// extracted by mini-css-extract-plugin
export default {"card":"ActiveClients_card__mmlec"};